<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Terminy</h1>
		</v-card-title>
		<v-container fluid>
			<v-layout row align-center>
				<v-flex xs4>
					<strong style="font-size: 16px;" class="ma-4">Termin wykorzystania dotacji</strong>
				</v-flex>
				<v-flex xs1 style="display: flex; justify-content: center">
					<strong style="font-size: 16px;" class="ma-4">od:</strong>
				</v-flex>
				<v-flex xs2 style="display: flex; justify-content: center" @click="showPermissionsInfo()">
					<v-menu ref="donationFromMenu" v-model="donationFromMenu" :close-on-content-click="false" :nudge-right="40"
						lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px" :disabled="!hasProjectPanelSupervisorModificationAccess()">
						<template v-slot:activator="{ on }">
							<v-text-field browser-autocomplete="off" v-model="data.donationFrom" for="donation-from-date-field"
								id="donation-from-date-field" aria-label="date menu item" v-on="on" readonly/>
						</template>
						<v-date-picker v-model="data.donationFrom" :first-day-of-week="1" no-title scrollable
							@input="donationFromMenu = false" locale="pl-PL"></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs1 style="display: flex; justify-content: center">
					<strong style="font-size: 16px;" class="ma-4">do:</strong>
				</v-flex>
				<v-flex xs2 @click="showPermissionsInfo()">
					<v-menu ref="donationToMenu" v-model="donationToMenu" :close-on-content-click="false" :nudge-right="40"
						lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px" :disabled="!hasProjectPanelSupervisorModificationAccess()">
						<template v-slot:activator="{ on }">
							<v-text-field browser-autocomplete="off" v-model="data.donationTo" for="donation-to-date-field"
								id="donation-to-date-field" aria-label="date menu item" v-on="on" readonly/>
						</template>
						<v-date-picker v-model="data.donationTo" :first-day-of-week="1" no-title scrollable
							@input="donationToMenu = false" locale="pl-PL"></v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
			<v-layout row align-center class="mb-4">
				<v-flex xs4>
					<strong style="font-size: 16px;" class="ma-4">Termin wykorzystania wkładu własnego</strong>
				</v-flex>
				<v-flex xs1 style="display: flex; justify-content: center">
					<strong style="font-size: 16px;" class="ma-4">od:</strong>
				</v-flex>
				<v-flex xs2 style="display: flex; justify-content: center" @click="showPermissionsInfo()">
					<v-menu ref="contributionFromMenu" v-model="contributionFromMenu" :close-on-content-click="false" :nudge-right="40"
						lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px" :disabled="!hasProjectPanelSupervisorModificationAccess()">
						<template v-slot:activator="{ on }">
							<v-text-field browser-autocomplete="off" v-model="data.contributionFrom" for="contribution-from-date-field"
								id="contribution-from-date-field" aria-label="date menu item" v-on="on" readonly/>
						</template>
						<v-date-picker v-model="data.contributionFrom" :first-day-of-week="1" no-title scrollable
							@input="contributionFromMenu = false" locale="pl-PL"></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs1 style="display: flex; justify-content: center">
					<strong style="font-size: 16px;" class="ma-4">do:</strong>
				</v-flex>
				<v-flex xs2 @click="showPermissionsInfo()">
					<v-menu ref="contributionToMenu" v-model="contributionToMenu" :close-on-content-click="false" :nudge-right="40"
						lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px" :disabled="!hasProjectPanelSupervisorModificationAccess()">
						<template v-slot:activator="{ on }">
							<v-text-field browser-autocomplete="off" v-model="data.contributionTo" for="contribution-to-date-field"
								id="contribution-to-date-field" aria-label="date menu item" v-on="on" readonly/>
						</template>
						<v-date-picker v-model="data.contributionTo" :first-day-of-week="1" no-title scrollable
							@input="contributionToMenu = false" locale="pl-PL"></v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
			<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow browser-autocomplete="off"
						v-model="data.termRemarks" aria-label="term remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveProjectTerms">Zapisz</v-btn>
			<egranty-error-list-popup
					title="Brak dostępu"
					:error-list="['Nie masz wystarczających uprawnień do wykonania tego działania. Działanie może być wykonane przez administratora lub opiekuna projektu.']"
					:is-open="errorDialog.showPopup"
					@close="errorDialog.showPopup = false"
				/>
		</v-container>
	</v-card>
</template>

<script>
	import {Project} from "@/api/generated/Project";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";

	export default {
		name: "ProjectTermsView",
		components: {
			EgrantyErrorListPopup
		},

		data() {
			return {
        data: {
          termRemarks: "",
          donationFrom: null,
          donationTo: null,
          contributionFrom: null,
          contributionTo: null
        },
        donationFromMenu: false,
        donationToMenu: false,
        contributionFromMenu: false,
        contributionToMenu: false,
		errorDialog: {
					showPopup: false,
					messages: [],
				},
			};
		},

		created() {
			Project.getTerms(this, this.$route.params.projectId, successResponse => {
					this.data = successResponse;
				}, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować terminów", errorResponse);
      });
		},

		methods: {
			hasProjectPanelSupervisorModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			showPermissionsInfo(){
				if(!this.hasProjectPanelSupervisorModificationAccess()){
					this.errorDialog.showPopup = true;
				}
			},
			saveProjectTerms() {
				Project.putTerms(this, this.$route.params.projectId, this.data, successResponse => {
          this.$messagesBus.$emit("success", "Dane zostały pomyślnie zapisane", successResponse);
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się zapisać danych", errorResponse);
        });
			}
		}
	};
</script>

<style scoped>
>>> .v-text-field input {
  font-size: 16px;
}
</style>
